import EventEmitter from 'eventemitter3'

type EventType =
	| 'open-password-modal'
	| 'open-signout-modal'
	| 'open-wallet-warning-modal'
	| 'open-insufficient-funds-modal'
	| 'open-broadcast-modal'
	| 'open-sell-modal'
	| 'open-purchase-modal'
	| 'purchase-completed'
	| 'open-moonpay-modal'
	| 'snackbar'
	| 'logged-in-out'
	| 'upload-progress'
	| 'list-item'
	| 'connect-wallet-closed'
	| 'floating-menu'
	| 'inscribe-modal'
	| 'bitmap-canvas'
	| 'bitmap-canvas-controls'
	| 'bitmap-header'
	| 'open-get-notifications-modal'
	| 'open-inscription-modal'
	| 'command'
	| 'add-to-cart'
	| 'alkanes-feed-refresh'

type EventPayload = { [key: string]: any }

class Event {
	eventEmitter: EventEmitter

	constructor() {
		this.eventEmitter = new EventEmitter()
	}

	emit(event: EventType, payload?: EventPayload) {
		this.eventEmitter.emit(event, payload)
	}

	listen(event: EventType, fn: (payload: EventPayload) => void) {
		this.eventEmitter.on(event, fn)
	}

	removeListener(event: EventType, fn: any) {
		this.eventEmitter.removeListener(event, fn)
	}
}

// Turbopack can evaluate this module twice across client boundaries. The
// command palette listens on one copy while wallet actions emit on the other,
// so a plain module singleton drops `command` events. Pin the instance on
// globalThis so every copy shares one bus.
const globalScope = globalThis as typeof globalThis & { __ordinalsWalletEvent?: Event }
const event = globalScope.__ordinalsWalletEvent ?? new Event()
globalScope.__ordinalsWalletEvent = event
export { event as default }
